export default __webpack_public_path__ + "static/media/csv.84b1827c.png";